import { AddCommar, ConvertDateToText } from 'components/MyControl';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';

export default function ProfilePackage(
    { data = undefined,
        setDataToParent = undefined,
        callSubmitParentData = undefined,
        parentAlert = '' }) {
    //console.log(data);
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);

    const [simulate, setSimulate] = useState(data);

    useEffect(() => {
        setSimulate(data);
    }, [data]);

    return (
        <div className='mt-3 mb-3'>
            <Form noValidate validated={validated}  >
                <div className={`border rounded p-4 bg-white shadow w-100`}>
                    <h5 className='mb-4 text-start text-blue-01'>ข้อมูลแพ็กเกจ</h5>
                    <div>
                        <Row className='mb-5'>
                            <Col className='me-3'>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>แพ็กเกจ</Form.Label>
                                    <Form.Control
                                        plaintext={true}
                                        readOnly={true}
                                        value={simulate?.package_master_name}
                                    />
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>ระยะเวลาเช่าซื้อ</Form.Label>
                                    <Form.Control
                                        plaintext={true}
                                        readOnly={true}
                                        value={simulate?.package_master_period_name
                                            + ' (' + ConvertDateToText(simulate?.effective_date) + ' - ' + ConvertDateToText(simulate?.expiry_date) + ')'
                                        }
                                    />
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>จำนวนผู้ใช้งาน</Form.Label>
                                    <Form.Control
                                        plaintext={true}
                                        readOnly={true}
                                        value={simulate?.user_volume + ' A/C'}
                                    />
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>พื้นที่จัดเก็บไฟล์</Form.Label>
                                    <Form.Control
                                        plaintext={true}
                                        readOnly={true}
                                        value={simulate?.storage_volume + ' GB'}
                                    />
                                </Form.Group>

                            </Col>
                            <Col className='me-3'>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>สถานะการชำระค่าบริการ</Form.Label>
                                    <Form.Control
                                        plaintext={true}
                                        readOnly={true}
                                        value={
                                            simulate?.payment_status_name

                                            + ' (' + ConvertDateToText(simulate?.paid_date) + ')'
                                        }
                                    />
                                </Form.Group>
                                {
                                    simulate?.payment_status_id === 1 &&
                                    <Form.Group className='mb-2'>
                                        <Form.Label className='label-title'>วันที่ครบกำหนดชำระ</Form.Label>
                                        <Form.Control
                                            plaintext={true}
                                            readOnly={true}
                                            value={
                                                ConvertDateToText(simulate?.due_date)
                                            }
                                        />
                                    </Form.Group>
                                }

                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>สถานะตรวจสอบการชำระ</Form.Label>
                                    <Form.Control
                                        plaintext={true}
                                        readOnly={true}
                                        value={simulate?.audit_status_name
                                            + ' (' + ConvertDateToText(simulate?.audit_date) + ')'
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                    </div>
                </div>
            </Form>
        </div>
    );
}